import React, { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import { Loader2 } from "lucide-react";

const BenchmarkImportPage: React.FC = () => {
  const [status, setStatus] = useState<"idle"|"uploading"|"success"|"error">("idle");
  const [message, setMessage] = useState<string>("");
  
  async function handleFileInput(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file) return;
    setStatus("uploading");
    setMessage("");
    try {
      const content = await file.text();
      const jsonData = JSON.parse(content);
      const importBenchmark = httpsCallable(functions, "import_benchmark");
      const result = await importBenchmark(jsonData) as any;

      if(result.data && result.data.success){
        setStatus("success");
        setMessage(result.data.message);
      } else {
        setStatus("error");
        setMessage(result.data?.error || "Errore sconosciuto.");
      }
    } catch(e: any) {
      setStatus("error");
      setMessage(e.message || "Errore nella lettura o nell'upload.");
    }
  }
  
  return (
    <div className="max-w-xl mx-auto mt-12 bg-black/60 border border-terminal-green p-6 rounded font-vt323 text-terminal-green text-lg">
      <h2 className="font-press-start text-2xl mb-6 text-center">Importa Benchmark</h2>
      <div className="mb-6 text-terminal-green/80">
        Seleziona un file JSON con il benchmark da importare su Firestore.
      </div>
      <input type="file" accept="application/json" onChange={handleFileInput} 
        className="file:bg-terminal-green/30 file:border file:rounded file:px-2 file:py-1 file:text-terminal-green mb-4" />

      {status === "uploading" && (
        <div className="flex items-center gap-2">
          <Loader2 className="animate-spin" size={22} /> Caricamento...
        </div>
      )}
      {status === "success" && <div className="text-green-400">{message}</div>}
      {status === "error" && <div className="text-red-500">{message}</div>}
    </div>
  );
};

export default BenchmarkImportPage;